import { render } from "./LetterIcon.vue?vue&type=template&id=673d60da"
import script from "./LetterIcon.vue?vue&type=script&lang=js"
export * from "./LetterIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__